module.exports = __webpack_public_path__ + "static/svd-1da6f262b8ed761b43617682c9276038.jpg";